import { render, staticRenderFns } from "./DialogSelecaoLoja.vue?vue&type=template&id=a3c834f6&scoped=true&lang=pug"
import script from "./DialogSelecaoLoja.vue?vue&type=script&lang=js"
export * from "./DialogSelecaoLoja.vue?vue&type=script&lang=js"
import style0 from "./DialogSelecaoLoja.vue?vue&type=style&index=0&id=a3c834f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c834f6",
  null
  
)

export default component.exports